import accountSettingsModule from '../accountSettingsModule';

function displayNameLayout($log, languageResource) {
  'ngInject';

  const lang = languageResource;

  return {
    changeDisplayNameLayout: {
      isRequestFailed: false,
      isValidated: true,
      isValidating: false,
      modalTitle: lang.get('Label.ConfigureDN'), // Change Display Name
      modalCancel: lang.get('Action.CancelDN'), // "Close",
      modalSave: lang.get('Action.SaveDN'), // "Save",
      modalDescriptionWarning: lang.get('Description.WarningFrequencyOfChanges'),
      displayErrorMsg: '',
      maxCharactersForDisplayName: 20,
      minCharactersForDisplayName: 3
    },

    changeDisplayNameResponse: {
      errorMessages: {
        nameContainPII: lang.get('ErrorMessage.NameContainPII'), // Displayname might contain private information
        nameHasChanged: lang.get('ErrorMessage.NameHasChanged'), // Your Displayname has already been changed in the past 7 days
        nameInappropriate: lang.get('ErrorMessage.NameInappropriate'), // Displayname not appropriate for Roblox
        nameTooLong: lang.get('ErrorMessage.NameTooLong'), // Displayname should have 20 characters at the most
        nameTooShort: lang.get('ErrorMessage.NameTooShort'), // Displayname should have 3 characters at least
        nameUnsupportedChars: lang.get('ErrorMessage.NameUnsupportedChars') // Displayname contains unsupported characters
      },
      errorCodeMapMsg: {
        1: 'nameTooShort',
        2: 'nameTooLong',
        3: 'nameUnsupportedChars',
        4: 'nameInappropriate',
        5: 'nameHasChanged'
      }
    }
  };
}

accountSettingsModule.factory('displayNameLayout', displayNameLayout);

export default displayNameLayout;
